// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1oCB1","errors":"Errors_errors__1sa08"};